module.exports = __webpack_public_path__ + "img/personio.54baacf1.svg";